import colors from '../colors';

const children = {
  backgroundColor: colors.graySecondary,
};

export default {
  children,
};
